import { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { reloadWorkspaces, useWorkspace } from 'hooks/useWorkspace';

import beaconLogo from 'assets/BeaconLogo.svg';

import { ROUTES } from 'routes/route.constants';

import { acceptInvitation } from 'services/invitationsService';

import { errorReactToastify } from 'utlis/toasts';

import InviteFlowLayout from './InviteFlowLayout';

import styles from './InviteFlow.module.scss';

const PendingInvite = ({ invitation, token }) => {
  const navigate = useNavigate();
  const { selectWorkspace } = useWorkspace();
  const [isJoining, setIsJoining] = useState(false);

  const workspace = invitation.workspace;
  const inviterName = invitation.inviter?.full_name || 'Someone';
  const inviterInitial = inviterName.charAt(0).toUpperCase();

  const handleJoin = async () => {
    if (isJoining) {
      return;
    }

    setIsJoining(true);

    try {
      const joinedWorkspace = await acceptInvitation(token);

      if (joinedWorkspace?.uuid) {
        selectWorkspace(joinedWorkspace.uuid);
      }

      reloadWorkspaces();
      navigate(ROUTES.TEAM_HOME);
    }
    catch (err) {
      errorReactToastify(
        err?.response?.data?.detail || err?.message || 'Failed to join workspace'
      );
      setIsJoining(false);
    }
  };

  return (
    <InviteFlowLayout>
      <div className={styles['workspace-icon']}>
        {workspace?.avatar_url
          ? (
            <img src={workspace.avatar_url} alt={workspace.name} />
          )
          : (
            <img src={beaconLogo} alt="Workspace" />
          )}
      </div>

      <div className={styles['copy']}>
        <p className={styles['copy-subtitle']}>
          You've been invited to join
        </p>
        <h1 className={styles['copy-title']}>
          {workspace?.name}
        </h1>
        <div className={styles['inviter-row']}>
          <div className={styles['inviter-avatar']}>
            {invitation.inviter?.avatar_url
              ? <img src={invitation.inviter.avatar_url} alt={inviterName} />
              : inviterInitial}
          </div>
          <span className={styles['inviter-text']}>
            You were invited by
            {' '}
            {inviterName}
          </span>
        </div>
      </div>

      <button
        type="button"
        onClick={handleJoin}
        disabled={isJoining}
        className={styles['cta-button']}
      >
        {isJoining ? 'Joining...' : 'Join workspace'}
      </button>
    </InviteFlowLayout>
  );
};

PendingInvite.propTypes = {
  invitation: PropTypes.shape({
    workspace: PropTypes.shape({
      name: PropTypes.string,
      avatar_url: PropTypes.string,
    }),
    inviter: PropTypes.shape({
      full_name: PropTypes.string,
      avatar_url: PropTypes.string,
    }),
  }).isRequired,
  token: PropTypes.string.isRequired,
};

export default PendingInvite;
